const developerData = [
    {
        id: 1,
        logo: 'https://res.cloudinary.com/dke9xzbl6/image/upload/v1640374892/Developer/html_wdldp9.png',
        name: 'html',
        link: 'https://html.com/'
    },
    {
        id: 2,
        logo: 'https://res.cloudinary.com/dke9xzbl6/image/upload/v1640374811/Developer/css_jd6toy.png',
        name: 'CSS',
        link: 'https://en.wikipedia.org/wiki/CSS'
    },
    {
        id: 3,
        logo: 'https://res.cloudinary.com/dke9xzbl6/image/upload/v1640376252/Developer/js_dg64xp.png',
        name: 'JS',
        link: 'https://www.javascript.com/'
    },
    {
        id: 4,
        logo: 'https://res.cloudinary.com/dke9xzbl6/image/upload/v1640379141/Developer/Reactjs_tigf5f.png',
        name: 'React JS',
        link: 'https://reactjs.org/'
    },
    {
        id: 5,
        logo: 'https://res.cloudinary.com/dke9xzbl6/image/upload/v1640379557/Developer/nodejs_qnvhic.png',
        name: 'Node JS',
        link: 'https://nodejs.org/en/'
    },
    {
        id:6,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1644058967/Developer/sass_uhnzaz.png',
        name:'SASS',
        link:'https://sass-lang.com/'
        },
    {
        id:7,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1656421090/Developer/express_js_vo6u27.png',
        name:'ExpressJS',
        link:'https://expressjs.com/'
        }
];

const designerData=[
    {
        id:1,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1644059091/Developer/ad_phtshp_c0engr.png',
        name:'Adobe Photoshop',
        link:'https://www.adobe.com/'
    },
    {
        id:2,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1644059337/Developer/ad_illu_y5knub.png',
        name:'Adobe Illustrator',
        link:'https://www.adobe.com/'
    },
    {
        id:3,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1644059502/Developer/figma_bssxcs.png',
        name:'Figma',
        link:'https://www.figma.com/'
    },
    {
        id:4,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1644059393/Developer/ad_ae_coxsg2.png',
        name:'Adobe After Effects',
        link:'https://www.adobe.com/'
    },
    {
        id:5,
        logo:'https://res.cloudinary.com/dke9xzbl6/image/upload/v1644059743/Developer/filmora_wlxn0w.png',
        name:'Filmora',
        link:'https://filmora.wondershare.net/'
    },
]

export { developerData,designerData };